import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';
import type { Filter } from '@atlassian/jira-filters-common/src/model/index.tsx';
import type { Filter as RestFilter } from '@atlassian/jira-filters-common/src/rest/types.tsx';
import { transformFilter } from '@atlassian/jira-filters-common/src/services/transformers.tsx';
import type { Response } from './types.tsx';

export const transformFilters = (filters: RestFilter[], total: number): Response => {
	const order = filters.map((i) => i.id);
	const responsesById: {
		[key: string]: RestFilter;
	} = keyBy(filters, (filter) => filter.id);
	const page: {
		[key: string]: Filter;
	} = mapValues(responsesById, (response: RestFilter) => transformFilter(response));

	return {
		page,
		order,
		total,
	};
};
